import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { CreatePlayload } from "../../lib/token";
import { loginSuccess } from "./auth";
const initialState = {
  data: null,
  loading: false,
  ploading: false,
  error: null,
};

// Create the slice
const authselfie = createSlice({
  name: "selfie",
  initialState,
  reducers: {
    Starting(state) {
      state.loading = true;
      state.error = null;
    },
    PStarting(state) {
      state.ploading = true;
      state.error = null;
    },
    PSuccess(state, action) {
      state.data = action.payload;
      state.ploading = false;
      state.error = null;
    },
    Success(state, action) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    Failure: (state, action) => {
      state.loading = false;
      state.ploading = false;
      state.data = null;
      state.error = action.payload;
    },
  },
});

export const { Starting, Success, PSuccess, Failure, PStarting } =
  authselfie.actions;

export const UploadPicture = (file) => async (dispatch, getState) => {
  dispatch(PStarting());

  try {
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await axios.post("/private/upload", formData, config);

    if (response?.status === 201) {
      const user = response?.data;
      dispatch(PSuccess());
      dispatch(loginSuccess({ user }));
      const Token = CreatePlayload(CreatePlayload(response?.data));
      localStorage.setItem("logged", Token?.token);
      toast.success("Profile picture uploaded successfully");
    }
  } catch (error) {
    const errMsg = error?.response?.data?.message || "Upload failed";
    dispatch(Failure(errMsg));
    toast.error(errMsg);
  }
};

export const UpdateProfile = (data, navigate) => async (dispatch) => {
  try {
    dispatch(Starting());
    const response = await axios.post("/private/profile", data);
    if (response?.status === 201) {
      const user = response?.data;
      dispatch(loginSuccess({ user }));
      dispatch(Success());
      const Token = CreatePlayload(CreatePlayload(response?.data));
      localStorage.setItem("logged", Token?.token);
      window.dispatchEvent(new Event("logged"));
      toast.success("Profile updated successfully!");
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || err);
    dispatch(Failure(err?.response?.data?.message || err));
  }
};

export default authselfie.reducer;
